import { createContext, useContext } from 'react';

import { PlatformCheckoutSession, PlatformInvoice } from 'src/types';

// ----------------------------------------------------------------------

export type CheckoutStage =
  /** Asking our backend for a provider checkout session. */
  | 'preparing'
  /** Provider-hosted page is on screen, waiting for the shopper. */
  | 'checkout'
  /** Provider says it finished — our backend is verifying it. */
  | 'confirming'
  | 'success'
  | 'failed';

export type BillingCheckoutContextType = {
  /** Whether the in-app checkout is rolled out; falsy → fall back to `payment_url`. */
  isOpen: boolean;
  stage: CheckoutStage;
  session: PlatformCheckoutSession | null;
  failureReason: string | null;
  /** Omit the invoice to pay whatever is currently outstanding. */
  openCheckout: (invoiceId?: PlatformInvoice['id']) => void;
  retryCheckout: () => void;
  closeCheckout: () => void;
};

export const BillingCheckoutContext = createContext<BillingCheckoutContextType | null>(null);

export const useBillingCheckout = () => {
  const ctx = useContext(BillingCheckoutContext);

  if (!ctx) throw new Error('useBillingCheckout must be used within BillingCheckoutProvider');

  return ctx;
};
